export default "__VITE_ASSET__DeY9gEpK__"